import React from 'react';
import {Transitioner, UserItem} from 'components';

import useProjectStore from '../../stores/useProjectStore';

interface ISidebarLeftTeamProps {}

const SidebarLeftTeam = ({}: ISidebarLeftTeamProps) => {
  const users = useProjectStore(s => s.users) ?? [];
  const creator = users.find(u => u.projectRole === 'creator');
  const collabs = users.filter(u => u.projectRole === 'collab');
  return (
    <Transitioner>
      <div className="flex flex-col gap-4 mb-6">
        <h4 className="text-slate-800 dark:text-white font-semibold">Creator</h4>
        <UserItem user={creator!} />
      </div>
      <div className="flex flex-col gap-4 mb-6">
        <h4 className="text-slate-800 dark:text-white font-semibold">Collaborators</h4>
        {collabs.map(collab => {
          return <UserItem key={collab.uid} user={collab} />;
        })}
      </div>
    </Transitioner>
  );
};

export default React.memo(SidebarLeftTeam);
